export default __webpack_public_path__ + "static/media/pg-icon.fe80f324.webp";